<div [ngClass]="classes" class="alert alert-danger" role="alert">
  <span class="font-size-09" [translate]="message"></span>
</div>
